export default __webpack_public_path__ + "static/media/merdeka2026-popup-banner.287c7b63.jpg";